<script setup>
import { useI18n } from 'vue-i18n'
import { usePublicMoney } from '@/composables/usePublicMoney'

// Small "N+ days · amount/day" / "N+ people · amount each" hint chips under
// a listing's base price, driven by the `price_tiers` prop each public
// controller now serializes (`[{threshold:, amount_cents:}]`, already
// display-currency-converted server-side). Renders nothing when the
// listing has no assigned rate plan.
const props = defineProps({
  tiers: { type: Array, default: () => [] },
  kind:  { type: String, required: true } // 'duration' | 'group'
})

const { t } = useI18n()
const { formatMoney } = usePublicMoney()

function label(tier) {
  const amount = formatMoney(tier.amount_cents)
  return props.kind === 'group'
    ? t('public.pricing.groupTier', { n: tier.threshold, amount })
    : t('public.pricing.durationTier', { n: tier.threshold, amount })
}
</script>

<template>
  <ul v-if="tiers && tiers.length" class="price-tiers">
    <li v-for="(tier, i) in tiers" :key="i" class="price-tier">{{ label(tier) }}</li>
  </ul>
</template>

<style scoped>
.price-tiers {
  list-style: none; margin: 0.5rem 0 0; padding: 0;
  display: flex; flex-wrap: wrap; gap: 0.4rem;
}
.price-tier {
  font-size: 0.75rem; font-weight: 600;
  padding: 0.2rem 0.6rem; border-radius: 999px;
  color: var(--accent);
  background: color-mix(in oklch, var(--accent) 10%, var(--surface));
  border: 1px solid color-mix(in oklch, var(--accent) 30%, var(--line));
}
</style>
